"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Facebook, Twitter, Instagram, Linkedin, MapPin, Phone, Mail, ChevronRight } from "lucide-react";
function FooterQuickLinks() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i} className="h-5 w-24 bg-white/10 animate-pulse rounded-full" />)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="font-sans text-primary-foreground/90 hover:text-chart-2 transition-colors flex items-center gap-1 group">
            <ChevronRight className="size-3 text-chart-2 opacity-0 -ml-4 transition-all group-hover:opacity-100 group-hover:ml-0" />
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function SiteFooter() {
  const businessName = "Bark Bath Mobile Grooming";
  const businessDescription = "A luxe mobile pet spa delivering professional, stress-free grooming directly to your doorstep in New Jersey, Pennsylvania, and Delaware.";
  const phone = "302-PUP-WASH";
  const email = "barkbathmobile@gmail.com";
  const address = "Serving NJ, PA, & DE";
  const services = ["Full Spa Grooming", "Bath & Brush Out", "Puppy's First Spa", "Nail & Paw Care", "De-Shedding Treatment"];
  const socialLinks = [{
    icon: Facebook,
    href: "#"
  }, {
    icon: Twitter,
    href: "#"
  }, {
    icon: Instagram,
    href: "#"
  }, {
    icon: Linkedin,
    href: "#"
  }];
  const currentYear = new Date().getFullYear();
  return <section data-section-id="163023" id="footer" className="dark bg-primary text-primary-foreground pt-20 pb-8 px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          
          {}
          <div className="flex flex-col gap-6">
            <Link to="#">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1600414/img/barkbath_logo_white.png" alt="Bark Bath Mobile Grooming" className="h-10 w-auto" />
            </Link>
            <p className="font-sans text-primary-foreground/80 text-sm leading-relaxed max-w-xs">
              {businessDescription}
            </p>
            <div className="flex items-center gap-3 mt-2">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={i} data-index={i} to={social.href} className="flex items-center justify-center size-10 rounded-full bg-white/10 text-primary-foreground hover:bg-chart-2 hover:-translate-y-1 transition-all duration-300 shadow-lg" aria-label="Social Link">
                    <Icon className="size-4" />
                  </Link>;
            })}
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-serif text-2xl font-bold tracking-tight text-white">
              Quick Links
            </h3>
            <MenuProvider menu_id="42">
              <FooterQuickLinks />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-serif text-2xl font-bold tracking-tight text-white">
              Our Services
            </h3>
            <ul className="space-y-3">
              {services.map((service, i) => <li key={i} data-index={i} className="flex items-start gap-3 group">
                  <span className="mt-1.5 size-2 rounded-full bg-chart-2 shrink-0 transition-transform group-hover:scale-150" />
                  <span className="font-sans text-primary-foreground/90 group-hover:text-chart-2 transition-colors">
                    {service}
                  </span>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-serif text-2xl font-bold tracking-tight text-white">
              Get In Touch
            </h3>
            <ul className="space-y-5">
              <li className="flex items-start gap-4">
                <div className="flex items-center justify-center size-10 rounded-full bg-white/10 shrink-0">
                  <MapPin className="size-5 text-secondary" />
                </div>
                <div className="flex flex-col gap-1">
                  <span className="font-sans text-primary-foreground/90 text-sm">{address}</span>
                  <Link to="#" className="font-sans text-secondary text-sm hover:underline">
                    View Service Areas
                  </Link>
                </div>
              </li>
              <li className="flex items-center gap-4">
                <div className="flex items-center justify-center size-10 rounded-full bg-white/10 shrink-0">
                  <Phone className="size-5 text-secondary" />
                </div>
                <Link to="tel:3027879274" className="font-sans text-primary-foreground/90 hover:text-chart-2 transition-colors">
                  302-PUP-WASH
                </Link>
              </li>
              <li className="flex items-center gap-4">
                <div className="flex items-center justify-center size-10 rounded-full bg-white/10 shrink-0">
                  <Mail className="size-5 text-secondary" />
                </div>
                <Link to={`mailto:${email}`} className="font-sans text-primary-foreground/90 hover:text-chart-2 transition-colors">
                  {email}
                </Link>
              </li>
            </ul>
          </div>

        </div>

        {}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-sans text-sm text-primary-foreground/60">
            &copy; {currentYear} {businessName}. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="#" className="font-sans text-sm text-primary-foreground/60 hover:text-chart-2 transition-colors">
              Privacy Policy
            </Link>
            <Link to="#" className="font-sans text-sm text-primary-foreground/60 hover:text-chart-2 transition-colors">
              Terms of Service
            </Link>
          </div>
          <p className="font-sans text-sm text-primary-foreground/60">
            Made with <span className="text-chart-2 font-medium">Love for Paws</span>
          </p>
        </div>
      </div>
    </section>;
}